<template>
    
    <nav class="content-wrapper fixed top-0 z-50 w-full border-myblue2 border-t-4 text-mytext-primary bg-background-primary shadow-xl">
        <div class="flex items-center justify-between py-3 px-5 md:px-12">
            <a href="/" class="flex items-center">
              <img src="../../../public/mhardLight.png" alt="" class="w-8 h-8" v-if="this.theme == 'theme-light'">
              <img src="../../../public/mhardDark.png" alt="" class="w-8 h-8" v-else>
              <span class="mx-1"/>
              <div class="font-semibold text-xl font-mono">M.Hard</div>
            </a>

            <div class="flex items-center">
              <span id="langDropdown" class="text-sm cursor-pointer mx-1 px-1">
                <div class="relative inline-flex align-middle">
                  <button class="font-bold uppercase hover:shadow-lg outline-none focus:outline-none"
                   style="transition:all .15s ease" type="button" @click.prevent="toggleDropdownLang()" ref="btnLangDropdownRef">
                    {{ $i18n.locale.toUpperCase() }}
                  </button>
                <div v-bind:class="{'hidden': !dropdownPopoverLangShow, 'block': dropdownPopoverLangShow}"
                 class="bg-background-primary text-base float-left py-2 list-none text-left rounded shadow-lg mt-5" style="min-width:10rem" ref="popoverLangDropdownRef">
                  <span class="py-1 px-4 font-normal block w-full whitespace-no-wrap" @click.prevent="setLangLocale('en')">
                    English
                  </span>
                  <div class="h-0 my-1 border border-solid border-t-0 border-mytext-primary opacity-25"></div>
                  <span class="py-1 px-4 font-normal block w-full whitespace-no-wrap" @click.prevent="setLangLocale('ar')">
                    العربية
                  </span>
                </div>
                </div>
              </span>
              <span @click.prevent="toggleTheme" class="cursor-pointer mx-1 px-1">
                <i v-if="theme == 'theme-light'" class="fa fa-moon-o"></i>
                <i v-else class="fa fa-sun-o"></i>
              </span>
              <div id="descktop" class="hidden md:block">
                  <div class="flex flex-wrap items-center">
                      <a href="mailto:m.hard268@email.com" class="cursor-pointer mx-2">{{ $t('navbar.contact') }}</a>
                      <a href="https://github.com/m-HARD"><i class="fa fa-2x fa-github mx-1"></i></a>
                  </div>
              </div>
              <div id="phone" class="block md:hidden">
                <button @click="isOpen = !isOpen" class="px-2 focus:outline-none">
                    <i v-if="isOpen" class="fa fa-remove fa-lg"></i>
                    <i v-if="!isOpen" class="fa fa-reorder"></i>
                </button>
              </div>
            </div>
        </div>
        <div :class="isOpen ? 'block':'hidden'" class="md:hidden text-left px-2 pt2 pb-4">
            <a href="#" class="block px-2 py-1 rounded-lg hover:bg-gray-400">{{ $t('navbar.contact') }}</a>
            <a href="https://github.com/m-HARD" class="block px-2 py-1 rounded-lg hover:bg-gray-400">{{ $t('navbar.myPageGithup') }}<i class="fa fa-github"></i></a>
        </div>

    </nav>

</template>

<script>
import Popper from "popper.js";
export default {
  name: 'Navbar',
  data() {
      return {
          isOpen: false,
          theme: 'theme-light',
          dropdownPopoverLangShow: false
      }
  },
  methods: {
    toggleTheme(){
      this.theme = this.theme == 'theme-light' ? 'theme-dark' : 'theme-light';
      localStorage.setItem('theme',this.theme)
      this.dataForApp();
    },
    dataForApp(){
      this.$emit('dataForApp', this.theme);
    },
    toggleDropdownLang(){
      if(this.dropdownPopoverLangShow){
        this.dropdownPopoverLangShow = false;
      } else {
        this.dropdownPopoverLangShow = true;
        new Popper(this.$refs.btnLangDropdownRef, this.$refs.popoverLangDropdownRef, {
          placement: "bottom-start"
        });
      }
    },
    setLangLocale(locale){
      this.$i18n.locale = locale;
      localStorage.setItem('LangLocale',locale)
      this.toggleDropdownLang();
    }
  },
  created() {
    this.theme = localStorage.getItem('theme') || 'theme-light'
    this.$i18n.locale = localStorage.getItem('LangLocale') || this.$i18n.locale;
    this.dataForApp();
  },
}
</script>